import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MsisdnService } from '../msisdn.service';
import { Msisdn } from '../msisdns';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'cc-msisdn-checkbox-list',
  templateUrl: './msisdn-checkbox-list.component.html',
  styleUrls: ['./msisdn-checkbox-list.component.scss']
})
export class MsisdnCheckboxListComponent implements OnInit {
  @Input() initialMsisdns: string[] = [];
  @Output() updateMsisdns = new EventEmitter();

  public msisdns: Msisdn[];
  public selectAllMsisdnsCheckbox = new FormControl(false);
  public selectedMsisdns = new FormControl([]);

  constructor(public msisdnService: MsisdnService) {}

  ngOnInit() {
    this.msisdnService.msisdns().subscribe(items => {
      this.msisdns = items.filter(item => item.msisdn);
      this.fillInitialMsisdns();
    });
  }

  changeMsisdnsForEvent(event) {
    this.changeMsisdns(event.source.value.msisdn, event.checked);
  }

  private changeMsisdns(msisdn, checked) {
    let selectedMsisdnValue = this.selectedMsisdns.value;
    let selectAllMsisdnCheckboxValue = false;

    if (checked) {
      selectedMsisdnValue.push(msisdn);
    } else {
      selectedMsisdnValue = selectedMsisdnValue.filter(item => item !== msisdn);
    }

    this.selectedMsisdns.setValue(selectedMsisdnValue);

    if (selectedMsisdnValue.length) {
      // take the -1 one to adhere to personal webcall number which is not visible in msisdns
      selectAllMsisdnCheckboxValue = this.msisdns.length === selectedMsisdnValue.length - 1 ? true : null;
    }
    this.updateMsisdns.next(selectedMsisdnValue);

    this.selectAllMsisdnsCheckbox.setValue(selectAllMsisdnCheckboxValue);
  }

  changeSelectAllState(isSelect) {
    if (isSelect === null) {
      return;
    }
    const selectedValues = isSelect ? this.msisdns.map(item => item.msisdn) : []
    this.selectedMsisdns.setValue(selectedValues);
    this.updateMsisdns.next(selectedValues)
  }

  isChecked(msisdn) {
    return this.selectedMsisdns.value.filter(item => item === msisdn.msisdn).length;
  }

  fillInitialMsisdns() {
    this.initialMsisdns.forEach(msisdn => this.changeMsisdns(msisdn, true));
  }
}
